"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType["Acknowledge"] = "Acknowledge";
    NotificationType["Standard"] = "Standard";
    NotificationType["Directed"] = "Directed";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
